import Actions from '../../odata/actions';

const actions = new Actions('jobListingStatus', 'jobListingStatuses');

export default actions;
